<style lang="scss">





@media screen and (min-width: 55rem) {
  .aboutshoppinglist {
    margin-top: 5rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    .aboutshoppinglist-container {
      width: 80%;
      max-width: 1080px;

      .aboutshoppinglist-list {
        width: 100%;
        display: flex;
        flex-direction: column;
        .aboutshoppinglist-item {
          width: 100%;
          display: flex;
          flex-direction: row;
          justify-content: space-around;
          margin-top: 5rem;
          .aboutshoppinglist-left-container {
            width: 25%;
            height: 15rem;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            .aboutshoppinglist-left {
              width: 100%;
              height: 100%;
              background-size: cover;
              background-position: center center;
              background-image: url("/media/yintai/about-1.png");
            }
          }
          .aboutshoppinglist-right-container {
            width: 65%;
            height: 15rem;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            .aboutshoppinglist-right-title {
              font-size: 1.6rem;
              font-family:  'PingFang SC','Microsoft YaHei';
              color: #4b4b4b;
              margin-bottom: 1rem;
            }
            .aboutshoppinglist-right-text {
              font-size: 1.2rem;
              font-family:  'PingFang SC','Microsoft YaHei';
              color: #7f7f7f;
            }
          }
        }
      }
    }
  }
}
@media screen and (max-width: 55rem) {
  .aboutshoppinglist {
    margin-top: 5rem;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    .aboutshoppinglist-container {
      width: 80%;

      .aboutshoppinglist-list {
        width: 100%;
        display: flex;
        flex-direction: column;
        .aboutshoppinglist-item {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-top: 2rem;
          .aboutshoppinglist-left-container {
            width: 80%;
            height: 15rem;
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            .aboutshoppinglist-left {
              width: 100%;
              height: 100%;
              background-size: cover;
              background-position: center center;
              background-image: url("/media/yintai/about-1.png");
            }
          }
          .aboutshoppinglist-right-container {
            width: 80%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            .aboutshoppinglist-right-title {
              font-size: 1.6rem;
              font-family:  'PingFang SC','Microsoft YaHei';
              color: #4b4b4b;
              margin-bottom: 1rem;
              margin-top: 1rem;
            }
            .aboutshoppinglist-right-text {
              .aboutshoppinglist-right-text-item {
                font-size: 1.2rem;
                font-family:  'PingFang SC','Microsoft YaHei';
                color: #7f7f7f;
              }
            }
          }
        }
      }
    }
  }
}
</style>

<template>
  <div class="aboutshoppinglist">
    <div class="aboutshoppinglist-container">
      <div class="aboutshoppinglist-list">
        <div class="aboutshoppinglist-item">
          <div class="aboutshoppinglist-left-container">
            <div
              class="aboutshoppinglist-left"
              style="background-image: url('/media/yintai/flagship-store.jpg')"
            ></div>
          </div>
          <div class="aboutshoppinglist-right-container">
            <div class="aboutshoppinglist-right-title">首店</div>
            <div class="aboutshoppinglist-right-text">
              <div class="aboutshoppinglist-right-text-item">
                2020年-2022年，全国银泰百货入驻了330多家首店，其中，全国级首店30家，省级首店94家，从数量到质量再上台阶，银泰百货也借此领跑城市“首店经济”。
              </div>
            </div>
          </div>
        </div>

        <div class="aboutshoppinglist-item">
          <div class="aboutshoppinglist-left-container">
            <div
              class="aboutshoppinglist-left"
              style="background-image: url('/media/yintai/cat-list-6.png')"
            ></div>
          </div>
          <div class="aboutshoppinglist-right-container">
            <div class="aboutshoppinglist-right-title">专柜货，全网买</div>
            <div class="aboutshoppinglist-right-text">
              <div class="aboutshoppinglist-right-text-item">
                银泰百货实现了线上喵街APP、“银泰百货INTIME”微信小程序、“银泰百货”支付宝小程序等全渠道购买。线上线下的购物同款、同价、同营销，用户购物能获得全渠道无差别的消费体验。
              </div>
            </div>
          </div>
        </div>

        <!--<div class="aboutshoppinglist-item">
          <div class="aboutshoppinglist-left-container">
            <div
              class="aboutshoppinglist-left"
              style="background-image: url('/media/yintai/cat-list-2.png')"
            ></div>
          </div>
          <div class="aboutshoppinglist-right-container">
            <div class="aboutshoppinglist-right-title">定时达</div>
            <div class="aboutshoppinglist-right-text">
              <div class="aboutshoppinglist-right-text-item">
                银泰百货首创“定时达”服务，商场的工作人员只需一键操作，线上订单就能自动流转至最近的线下门店，由即时物流的配送员上门取货，包裹可以像外卖一样送达。此外，银泰旗下65家门店的商品均可以通过普通快递发往全国。消费者在喵街APP下单， 银泰百货旗下八成门店最快1小时定时达。
              </div>
            </div>
          </div>
        </div>

        <div class="aboutshoppinglist-item">
          <div class="aboutshoppinglist-left-container">
            <div
              class="aboutshoppinglist-left"
              style="background-image: url('/media/yintai/cat-list-3.png')"
            ></div>
          </div>
          <div class="aboutshoppinglist-right-container">
            <div class="aboutshoppinglist-right-title">奢品到家</div>
            <div class="aboutshoppinglist-right-text">
              <div class="aboutshoppinglist-right-text-item">
                “奢品到家”是银泰为奢侈品顾客推出的新零售专属服务。银泰通过门店网点化，做到比电商平台更快的“末端公里送达”，让顾客足不出户就能第一时间收到来自专柜的奢侈品。“奢品到家”还将陆续推出成衣修改、奢品养护、衣橱整理等服务，做到不仅把奢品送到家，更把奢体验也送到家。过去一年，奢品专送服务里程超过92万公里。
              </div>
            </div>
          </div>
        </div>-->

        <div class="aboutshoppinglist-item">
          <div class="aboutshoppinglist-left-container">
            <div
              class="aboutshoppinglist-left"
              style="background-image: url('/media/yintai/cat-list-7.png')"
            ></div>
          </div>
          <div class="aboutshoppinglist-right-container">
            <div class="aboutshoppinglist-right-title">惠员服务</div>
            <div class="aboutshoppinglist-right-text">
              <div class="aboutshoppinglist-right-text-item">
                银泰百货新增手部护理、美甲、表带更换、手机贴膜、珠宝清洗五个服务项目。加上此前一直在推行的“免费打车接送顾客逛街”、“全国包邮”、“异地异店无忧退换货”、“上门取件退换货”、“买贵赔差价”、“洗衣”、“改衣”、“洗车”、礼物包装、寄存柜、充电宝租借、送鸡蛋、 “暖心服务(点心等)”、“基础服务(无线上网等)”等服务，银泰百货全年常态化为顾客提供20多项服务。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "title",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>
